import React from "react";
import Layout from "../components/Layout";
import { dreamTables } from "../mock";
import useSeo from "../hooks/useSeo";

const DreamNumber = () => {
  useSeo(
    "Morning Sunday Teer Dream Number Today | Shillong Morning Teer Dream Chart",
    "Complete Shillong Morning Teer Dream Number chart — translate your dreams into Direct, House and Ending targets for Morning Sunday Teer.",
    { breadcrumb: [ { name: "Home", path: "/" }, { name: "Dream Number", path: "/dream-numbers" } ] }
  );
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 py-6">
        <h1 className="text-xl font-bold text-[#1f2a37] mb-2">
          Morning Sunday Teer Dream Number &amp; Shillong Cultural Targets
        </h1>
        <p className="text-[#374151] leading-relaxed mb-6 text-sm">
          Local participants believe that nighttime dreams carry hidden
          numerical codes. Find the symbol that matches your dream, extract the
          associated <b>Direct</b>, <b>House</b> and <b>Ending</b> digits, and
          refine your approach for today's Morning Sunday Teer sessions.
        </p>

        <div className="space-y-6">
          {dreamTables.map((tbl, i) => (
            <div key={i}>
              <h2 className="text-base font-bold text-[#1f2a37] mb-2">
                {tbl.title}
              </h2>
              <div className="border border-gray-300 rounded-md overflow-hidden">
                <table className="w-full text-center text-sm">
                  <thead>
                    <tr className="bg-[#3aa79a] text-white">
                      <th className="py-2 px-1 font-semibold text-left pl-3">
                        Dream Symbol
                      </th>
                      <th className="py-2 px-1 font-semibold">Direct</th>
                      <th className="py-2 px-1 font-semibold">House</th>
                      <th className="py-2 px-1 font-semibold">Ending</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tbl.rows.map((r, j) => (
                      <tr key={j} className={j % 2 ? "bg-gray-50" : "bg-white"}>
                        <td className="py-2 px-1 border-t border-gray-200 text-left pl-3 font-medium">
                          {r.symbol}
                        </td>
                        <td className="py-2 px-1 border-t border-gray-200">
                          {r.direct}
                        </td>
                        <td className="py-2 px-1 border-t border-gray-200 font-semibold">
                          {r.house}
                        </td>
                        <td className="py-2 px-1 border-t border-gray-200 font-semibold">
                          {r.ending}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-gray-500 italic mt-8">
          We provide these dream tables strictly for educational reference,
          traditional preservation and entertainment. Dream translations do not
          guarantee a confirmed win. Please play responsibly.
        </p>
      </div>
    </Layout>
  );
};

export default DreamNumber;
